module.exports = __webpack_public_path__ + "static/img/XO.c775c78f.svg";